import React, { useState } from 'react';
import servicesData from '../../../../Constant/Services';
import { useDispatch } from 'react-redux';
import { addProfessionalData } from '../../../../Redux/Slices/Pages/services/servicesSlice';
import { useNavigate } from 'react-router-dom';

const ProfessionalForm = () => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    category: '',
    profession: '',
    skills: [],
    description: '',
    baseLocation: '',
    hourlyRate: '',
    travelCharge: '',
    visitingFee: '',
    profileImage: null,
  });
 const navigate =useNavigate();
  console.log(formData, 'formdata');

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'category') {
      setFormData({ ...formData, category: value, profession: '', skills: [] });
    } else if (name === 'profession') {
      setFormData({ ...formData, profession: value, skills: [] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const toggleSkill = (skill) => {
    setFormData((prev) => ({
      ...prev,
      skills: prev.skills.includes(skill)
        ? prev.skills.filter((s) => s !== skill)
        : [...prev.skills, skill],
    }));
  };

  const handleImageUpload = (e) => {
    setFormData((prev) => ({
      ...prev,
      profileImage: URL.createObjectURL(e.target.files[0]),
    }));
  };

  const handleSave = () => {
    console.log('Submitted Data:', formData);
    dispatch(addProfessionalData(formData))
     window.location.reload();
  };

  const handleCancel = () => {
    setFormData({
      category: '',
      profession: '',
      skills: [],
      description: '',
      baseLocation: '',
      hourlyRate: '',
      travelCharge: '',
      visitingFee: '',
      profileImage: null,
    });
  };

  const selectedCategory = servicesData.find((c) => c.category === formData.category);
  const professions = selectedCategory?.profession || [];

  const selectedProfession = professions.find((p) => p.name === formData.profession);
  const skills = selectedProfession?.skills || [];

  return (
    <div className="mx-auto w-11/12">
      <h1 className="text-2xl font-bold mb-1 text-gray-800">Add My Profession</h1>
      <p className="text-gray-500 mb-6">Submit your service under the Bookizap platform.</p>

      {/* Category & Profession */}
      <div className="flex gap-4 mb-6">
        <div className="flex-1">
          <label className="block text-sm font-medium text-gray-700 mb-1">Category</label>
          <select
            name="category"
            value={formData.category}
            onChange={handleChange}
            className="w-full p-3 border rounded-md focus:ring focus:ring-blue-200"
          >
            <option value="">Select Category</option>
            {servicesData.map((cat, i) => (
              <option key={i} value={cat.category}>
                {cat.category}
              </option>
            ))}
          </select>
        </div>

        <div className="flex-1">
          <label className="block text-sm font-medium text-gray-700 mb-1">Profession</label>
          <select
            name="profession"
            value={formData.profession}
            onChange={handleChange}
            disabled={!formData.category}
            className="w-full p-3 border rounded-md focus:ring focus:ring-blue-200"
          >
            <option value="">Select Profession</option>
            {professions.map((p, i) => (
              <option key={i} value={p.name}>
                {p.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Skills */}
      {skills.length > 0 && (
        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">Select Skills</label>
          <div className="flex flex-wrap gap-3">
            {skills.map((skill, i) => (
              <label
                key={i}
                className={`px-4 py-2 border rounded-full cursor-pointer text-sm ${
                  formData.skills.includes(skill)
                    ? 'bg-blue-600 text-white border-blue-600'
                    : 'bg-gray-100 text-gray-700'
                }`}
              >
                <input
                  type="checkbox"
                  checked={formData.skills.includes(skill)}
                  onChange={() => toggleSkill(skill)}
                  className="hidden"
                />
                {skill}
              </label>
            ))}
          </div>
        </div>
      )}

      {/* Description */}
      <div className="mb-6">
        <label className="block mb-1 text-sm font-medium text-gray-700">Description</label>
        <textarea
          name="description"
          rows={4}
          value={formData.description}
          onChange={handleChange}
          className="w-full p-4 border rounded-md focus:ring focus:ring-blue-200"
          placeholder="Describe your experience and offerings..."
        />
      </div>

      {/* Base Location */}
      <div className="mb-6">
        <label className="block mb-1 text-sm font-medium text-gray-700">Base Location</label>
        <input
          type="text"
          name="baseLocation"
          value={formData.baseLocation}
          onChange={handleChange}
          className="w-full p-3 border rounded-md focus:ring focus:ring-blue-200"
          placeholder="Enter your base working location (e.g., Kochi, Thrissur)"
        />
      </div>

      {/* Image Upload & Charges */}
      <div className="flex items-start gap-6 mb-6">
        <div className="w-36 h-36 border rounded-md bg-gray-100 overflow-hidden flex items-center justify-center">
          {formData.profileImage ? (
            <img src={formData.image} alt="Uploaded" className="w-full h-full object-cover" />
          ) : (
            <label className="cursor-pointer text-sm text-gray-600">
              Upload Image
              <input type="file" onChange={handleImageUpload} className="hidden" />
            </label>
          )}
        </div>

        <div className="flex flex-col gap-4">
          <input
            type="number"
            name="hourlyRate"
            value={formData.hourlyRate}
            onChange={handleChange}
            className="p-2 border rounded-md w-44"
            placeholder="Hourly Rate"
          />
          <input
            type="number"
            name="travelCharge"
            value={formData.travelCharge}
            onChange={handleChange}
            className="p-2 border rounded-md w-44"
            placeholder="Travel Charge"
          />
          <input
            type="number"
            name="visitingFee"
            value={formData.visitingFee}
            onChange={handleChange}
            className="p-2 border rounded-md w-44"
            placeholder="Visiting Fee"
          />
        </div>
      </div>

      {/* Buttons */}
      <div className="flex gap-4">
        <button
          onClick={handleSave}
          className="bg-blue-700 hover:bg-blue-800 text-white px-6 py-3 rounded-md shadow"
        >
          SAVE PROFESSION
        </button>
        <button onClick={handleCancel} className="text-gray-500 hover:text-red-500 underline">
          CANCEL
        </button>
      </div>
    </div>
  );
};

export default ProfessionalForm;
